import type { AdvisorDashboardMilestones } from 'components/GlassCards/types';

/**
 * Derives tier display props from advisor milestones data.
 * A tier is considered valid when `tier_status.tier` is non-empty and not `"none"`.
 * @param milestones - Advisor milestones from the dashboard API, or `null` when unavailable.
 * @param metallicTiers - Whether the `metallic_tiers` feature flag is enabled.
 * @returns `slug` — lowercase tier identifier used for CSS class selection (empty string if no valid tier);
 *          `display` — human-readable tier label for rendering (falls back to `tier_status.label` when slug is absent);
 *          `showRow` — whether the tier row should be rendered at all.
 */
export function getTierPropsFromMilestones(
  milestones: AdvisorDashboardMilestones | null,
  metallicTiers: boolean,
): { slug: string; display: string; showRow: boolean } {
  const tierStatus = milestones?.tier_status;
  const rawTier = (tierStatus?.tier ?? '').trim();
  const isValidTier = rawTier !== '' && rawTier.toLowerCase() !== 'none';
  const slug = isValidTier ? rawTier.toLowerCase() : '';
  const display = isValidTier ? rawTier : (tierStatus?.label.trim() ?? '');
  const showRow = metallicTiers && milestones !== null && tierStatus !== undefined && slug !== '';
  return { slug, display, showRow };
}
